import {Api} from './api/api';
import {StylesProvider} from './providers/stylesProvider';
import {ScriptsProvider} from './providers/scriptsProvider';
import {createElement} from './helpers';

class Popup {
    static initToggle() {
        let toggleButtons = document.querySelectorAll('[data-popup-toggle]:not([data-init="1"])');
        Array.from(toggleButtons).forEach((toggleButton) => {
            toggleButton.addEventListener('click', (event) => {
                event.preventDefault();
                this.toggle(event.currentTarget);
            });

            toggleButton.setAttribute('data-init', '1');
        });
    }

    static initPopups() {
        let popups = document.querySelectorAll('[data-popup]');
        Array.from(popups).forEach((popup) => {
            this.init(popup);
        });

        if (popups.length) {
            this._togglePopup(popups[0]);
        }
    }

    /**
     * @param {Element} popup
     */
    static init(popup) {
        let eventListenerClose = (event) => {
                event.preventDefault();
                this.hide(event.currentTarget.getAttribute('data-popup-close'));
            },
            eventListenerMissClick = (event) => {
                event.preventDefault();
                this.hide(event.currentTarget.getAttribute('data-popup'));
            };

        let closeButtons = popup.querySelectorAll('[data-popup-close]');

        Array.from(closeButtons).forEach((closeButton) => {
            closeButton.removeEventListener('click', eventListenerClose);
            closeButton.addEventListener('click', eventListenerClose);
        });

        popup.removeEventListener('click', eventListenerMissClick);
        popup.addEventListener('click', eventListenerMissClick);
        popup.children[0].addEventListener('click', (event) => {
            event.stopPropagation();
        });
    }

    static hasOpen(popupKey) {
        let popup = document.querySelector(`[data-popup="${popupKey}"]`);
        return popup && !popup.classList.contains('is-none');
    }

    static hide(popupKey) {
        let popup = document.querySelector(`[data-popup="${popupKey}"]`);

        popup.classList.add('is-none');
        document.body.classList.remove('popup-body');

        popup.dispatchEvent(new Event('hide'));
    }

    static show(popupKey) {
        Array.from(document.querySelectorAll('[data-popup]')).forEach((element) => {
            element.classList.add('is-none');
        });

        document.querySelector(`[data-popup="${popupKey}"]`).classList.remove('is-none');
        document.body.classList.add('popup-body');
    }

    static toggle(toggleButton) {
        let popupKey = toggleButton.getAttribute('data-popup-toggle'),
            popup = document.querySelector(`[data-popup="${popupKey}"]`),
            requestParams = {};

        Array.from(toggleButton.attributes).forEach((attribute) => {
            if (attribute.nodeName.match(/^data-param-/)) {
                requestParams[attribute.nodeName.substr(11)] = attribute.nodeValue;
            }
        });

        if (popup) {
            if (Object.entries(requestParams).length || toggleButton.getAttribute('data-reload') === '1') {
                popup.remove();
            } else {
                return this._togglePopup(popup);
            }
        }

        this._load(toggleButton, requestParams);
    }

    /**
     * @param {Element} popupContent
     * @private
     */
    static _togglePopup(popupContent) {
        popupContent.classList.contains('is-none')
            ? this.show(popupContent.getAttribute('data-popup'))
            : this.hide(popupContent.getAttribute('data-popup'));
    }

    /**
     * @param {Element} toggleButton
     * @param {Object} requestParams
     * @private
     */
    static _load(toggleButton, requestParams) {
        Api.post(toggleButton.getAttribute('data-endpoint'), requestParams, (response) => {
            if (response.isFailure()) {
                return null;
            }

            let popupHideReopen = toggleButton.dataset.hideReopen;
            let popup = this.appendPopupAndToggle(
                response.get('content', ''),
                response.get('style'),
                response.get('script')
            );

            if (popupHideReopen) {
                popup.addEventListener('hide', () => {
                    popup.remove();
                    this.show(popupHideReopen);
                });
            }
        });
    }

    /**
     * @param {String} content
     * @param {String} style
     * @param {String} script
     * @return {Element}
     */
    static appendPopupAndToggle(content, style, script) {
        let popupContent = createElement(content).querySelector('[data-popup]');

        if (style) {
            StylesProvider.add(style);
        }

        if (script) {
            ScriptsProvider.add(script);
        }

        document.body.append(popupContent);
        let popup = document.querySelector(`[data-popup="${popupContent.getAttribute('data-popup')}"]`);

        this.init(popup);
        this._togglePopup(popup);

        return popup;
    }
}

export {Popup};
